import * as React       from 'react';
import LoadingAnimation from '../../components/LoadingAnimation';

const ConversationLoader = () => (
    <div className="messageFeed__view flexbox__column">
        <div className="flexbox__row">
            <LoadingAnimation />
        </div>
    </div>
);

export default ConversationLoader;



// WEBPACK FOOTER //
// ./src/sections/Conversation/ConversationLoader.tsx